<template>
  <div class="home">
    <img :src="currentImage" alt="当前展示的图片" class="full-screen-image" />
    <img src="@/assets/home/downward.png" alt="" @click="nextImage" class="arrow-button" />
    <div v-if="currentIndex === 0" class="download-box">
      <img @click="handleEvent1" class="ios-download" src="@/assets/home/Group 9.png" alt="">
      <img @click="handleEvent2" class="android-download" src="@/assets/home/Group 8.png" alt="">
    </div>
    <div v-if="currentIndex === 3" class="info-box">
      <p class="title">梅洛互娱</p>
      <p class="subtitle">梅洛网络科技（成都）有限公司</p>
      <img class="logo" src="@/assets/home/Group 5.png" alt="">
      <div class="bottom-layer">
        <p @click="aboutus">关于我们</p>
        <p>|</p>
        <p>联系方式：blueislegames@163.com </p>
        <p>|</p>
        <p @click="toPrivacyPage">隐私保护政策</p>
        <p>|</p>
        <p @click="toAuditingPage">信息发布审核制度</p>
        <p>|</p>
        <p @click="toUserPage">用户许可协议</p>
        <p>|</p>
        <p @click="toFaqPage">FQA</p>
      </div>
      <p class="copyright">Copyright © 2023.All rights reserved.蜀ICP备2023025167号-1</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      images: [
        require('@/assets/home/Frame 6.png'),
        require('@/assets/home/Frame 2.png'),
        require('@/assets/home/Frame 3.png'),
        require('@/assets/home/Frame 5.png')
      ],
      currentIndex: 0,
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    }
  },
  methods: {
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    // ios下载
    handleEvent1() {
      console.log('ios下载');
    },
    // 安卓下载
    handleEvent2() {
      console.log('安卓下载');
      const apkUrl = '/apk/dorpaPlus-app-android.apk'; // 公共目录路径
      const link = document.createElement('a');
      link.href = apkUrl;
      link.setAttribute('download', 'dorpaPlus-app-android.apk'); // 设置下载文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    aboutus() {
      // 跳转到其他网站
      window.location.href = 'http://www.blueislegames.com/';
    },
    toPrivacyPage() {
      // this.$router.push('/privacy');
      window.location.href = 'http://www.dorpa.net/dorpa_document/index.html?key=Privacy_Policy';
    },
    toFaqPage() {
      // this.$router.push('/faq');
      window.location.href = 'http://www.dorpa.net/dorpa_document/index.html?key=FQA';
    },
    toAuditingPage() {
      this.$router.push('/auditing');
    },
    toUserPage() {
      // this.$router.push('/userAgreement');
      window.location.href = 'http://www.dorpa.net/dorpa_document/index.html?key=User_Agreement';
    }
  }
};
</script>

<style scoped>
.home {
  position: relative;
  width: 100vw;
  height: 100vh; 
  overflow: hidden; 
}

.full-screen-image {
  width: 100%;
  height: 100%;
  display: block; 
  object-fit: cover;
  position: relative;
}

.arrow-button {
  width: 28px;
  height: 15px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  z-index: 999;
}

.download-box {
  width: 50%;
  height: 200px;
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 43px;
}

.extra-buttons button {
  padding: 8px 16px;
  font-size: 16px;
  cursor: pointer;
}

.ios-download {
  width: 150px;
  height: 60px;
  cursor: pointer;
}

.android-download {
  width: 275px;
  height: 50px;
  cursor: pointer;
}

.info-box {
  width: 60%;
  height: 180px;
  position: absolute;
  top: 89%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  gap: 10px;
}

.title {
  font-size: 30px;
}

.subtitle {
  font-size: 18px;
}

.logo {
  width: 75px;
  height: 40px;
  position: absolute;
  top: 50px;
  left: 340px;
}

.bottom-layer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 16px;
  cursor: pointer;
}

.copyright {
  font-size: 16px;
}
</style>